const sourceKeysCompeso = {
    title: 'title',
    original_title: 'original_title',
    description: 'description',
    genres: 'genres',
    trailerURL: 'trailer_url',
    actors: 'cast',
    starting_date: 'cinema_start',
    visible_from: 'visible_from',
}

const sourceKeysKinoheld = {
    title: 'title',
    description: 'description',
    genres: 'genres',
    trailerURL: 'trailerUrls',
    actors: 'actors',
}

const sourceKeysMars = {
    title: 'title',
    original_title: 'orig_title',
    description: 'description',
    genres: 'genres',
    trailerURL: 'trailer_url',
    actors: 'actors',
    starting_date: 'starting_date',
}

const sourceKeysCortec = {
    title: 'title',
    description: 'description',
    genres: 'genre',
    trailerURL: 'trailer',
    actors: 'actors',
}

const sourceKeysMarsX = {
    title: 'title',
    description: 'description',
    genres: 'genres',
    trailerURL: 'link_movie_trailer',
    actors: 'actors',
}

const sourceKeysVista = {
    title: 'title',
    description: 'synopsis',
    genres: 'genres',
    trailerURL: 'trailer_url',
    starting_date: 'opening_date',
}

const sourceKeysDieselV2 = {
    title: 'title',
    starting_date: 'release_date_naive',
}

const PROVIDER_SOURCE_KEYS = {
    Compeso: sourceKeysCompeso,
    Kinoheld: sourceKeysKinoheld,
    Mars: sourceKeysMars,
    Cortec: sourceKeysCortec,
    MarsX: sourceKeysMarsX,
    Vista: sourceKeysVista,
    DieselV2: sourceKeysDieselV2,
}

const movieAttrToSourceAttr = (movieKey, provider) => {
    const keys = PROVIDER_SOURCE_KEYS[provider] || {}
    return keys.hasOwnProperty(movieKey) ? keys[movieKey] : false
}

export default movieAttrToSourceAttr
